import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './config/i18n';
// import * as serviceWorker from './config/serviceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
// serviceWorker.register();
